import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName = "Forfait avec Engagement" | "Gestion+ avec Engagement" | "Saisie PREMIER" | "Gestion+" | "eCofiCoffre";

export type CofidocHistory = {
  date?: Date;
  turnover?: number;
  nbReplacing?: number;
  monthlyTurnoverMin?: number;
  monthlyTurnoverMax?: number;
  productName?: string;
};

type FetchCofidocHistoryParams = {
  username?: string | null;
  email?: string | null;
};

export async function fetchCofidocHistory({ username, email }: FetchCofidocHistoryParams = {}) {
  const queryParams = new URLSearchParams();
  if (username) queryParams.append("username", username);
  if (email) queryParams.append("email", email);

  const queryString = queryParams.toString();
  const url = `/account/history${queryString ? `?${queryString}` : ""}`;

  const res = await fetchAPI({
    url,
    options: {
      method: "GET",
    },
  });

  return res;
}
